<script>
  export let columns;
  export let center = false;

  export let ref;
  export let containerElement = "div";
  let clazz = "";
  /** @type { string } */
  export { clazz as class };

  const smClassNames = {
    // column count: gridItemClassName
    1: "grid-cols-1",
    2: "grid-cols-2",
    3: "grid-cols-3",
    4: "grid-cols-4",
    5: "grid-cols-5",
    6: "grid-cols-6"
  };
  const mdClassNames = {
    // column count: gridItemClassName
    1: "md:grid-cols-1",
    2: "md:grid-cols-2",
    3: "md:grid-cols-3",
    4: "md:grid-cols-4",
    5: "md:grid-cols-5",
    6: "md:grid-cols-6"
  };
  const lgClassNames = {
    // column count: gridItemClassName
    1: "lg:grid-cols-1",
    2: "lg:grid-cols-2",
    3: "lg:grid-cols-3",
    4: "lg:grid-cols-4",
    5: "lg:grid-cols-5",
    6: "lg:grid-cols-6"
  };

  function deriveClassesFromColCount(colCount) {
    if (Number.isInteger(colCount)) {
      return smClassNames[colCount];
    } else {
      const { sm, md, lg } = colCount;
      return [smClassNames[sm], mdClassNames[md], lgClassNames[lg]].filter((v) => !!v).join(" ");
    }
  }
</script>

<svelte:element
  this={containerElement}
  bind:this={ref}
  class="w-full grid grid-flow-row {deriveClassesFromColCount(columns)} {clazz}"
  class:justify-items-center={center}
  {...$$restProps}
>
  <slot />
</svelte:element>
